import { API, ApiResponse, handleApiResponse, handleApiError } from './config';

/**
 * Datos de una transacción en el reporte
 */
export interface ReportTransaction {
  id: string;
  xid: string;
  phone_number: string;
  type: number;
  amount: number;
  date: string;
  operator: string;
  status: number;
  commission: string;
}

/**
 * Detalle para mostrar en el recibo
 */
export interface TransactionDetail {
  key: string;
  value: string;
}

/**
 * Respuesta de reporte
 */
export interface ReportResponse {
  current_page: number;
  last_page: number;
  totals_solds: number;
  total_reverse: number;
  total_error: number;
  total_amount: string;
  total_commission: string;
  data: ReportTransaction[];
}

/**
 * Respuesta con detalles de transacción
 */
export interface TransactionDetailsResponse {
  canReverse: boolean;
  ticket: string;
  data: TransactionDetail[];
}

/**
 * Servicio para reportes y gestión de transacciones
 */
export const reportService = {
  /**
   * Obtener datos de reporte según filtros
   */
  getReportData: async (
    from_date: string,
    to_date: string,
    type: number,
    page: number = 1
  ): Promise<ApiResponse<ReportResponse>> => {
    try {
      const response = await API.post('/get-report-data', {
        from_date,
        to_date,
        type,
        page,
      });
      return handleApiResponse(response);
    } catch (error) {
      throw handleApiError(error);
    }
  },

  /**
   * Obtener detalles de una transacción específica
   */
  getTransactionDetail: async (
    id: string
  ): Promise<ApiResponse<TransactionDetailsResponse>> => {
    try {
      const response = await API.post('/get-transaction-details', { id });
      return handleApiResponse(response);
    } catch (error) {
      throw handleApiError(error);
    }
  },

  /**
   * Reversar una transacción
   */
  reverseTransaction: async (id: string): Promise<ApiResponse<null>> => {
    try {
      const response = await API.post('/reverse-transaction', { id });
      return handleApiResponse(response);
    } catch (error) {
      throw handleApiError(error);
    }
  },

  /**
   * Genera el ticket PDF de una transacción y devuelve su URL
   * El backend usa el id (entero de BD), no el xid
   */
  generateTicket: async (transactionId: number | string): Promise<ApiResponse<{ url: string }>> => {
    try {
      const response = await API.post('/generate-ticket', { transactionId });
      return handleApiResponse(response);
    } catch (error) {
      throw handleApiError(error);
    }
  },

  /**
   * Enviar comprobante por WhatsApp
   */
  sendWhatsappMessage: async (
    id: string,
    phone_number: string
  ): Promise<ApiResponse<null>> => {
    try {
      const response = await API.post('/send-whatsapp-message', {
        id,
        phone_number
      });
      return handleApiResponse(response);
    } catch (error) {
      throw handleApiError(error);
    }
  }
};
